import { FormControl, InputLabel, Select, MenuItem, Button, Paper, Tooltip } from "@mui/material"
import DownloadIcon from "@mui/icons-material/Download"
import styled from "@emotion/styled"

const SORT_OPTIONS = [
  { value: "name", label: "Name" },
  { value: "client", label: "Client" },
  { value: "account", label: "Account" },
  { value: "department", label: "Department" },
  { value: "project", label: "Project" },
  { value: "group", label: "Group" },
  { value: "responsibleUser", label: "Responsible" },
  { value: "budgetedTime", label: "Budgeted Time" },
  { value: "quotedTime", label: "Quoted Time" },
  { value: "actualTime", label: "Actual Time" },
  { value: "type", label: "Type" },
  { value: "startDate", label: "Start Date" },
  { value: "dueDate", label: "Due Date" },
  { value: "createdAt", label: "Created Date" },
  { value: "updatedAt", label: "Last Activity Date" },
  { value: "priority", label: "Priority" },
];

const GROUP_OPTIONS = SORT_OPTIONS.filter((option) => !["budgetedTime", "quotedTime", "actualTime", "name"].includes(option.value));

const SortingPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1.5, 2),
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: theme.spacing(1.5),
}));

const SortingField = styled(FormControl)(({ theme }) => ({
  minWidth: "170px",
  flex: "1 1 170px",
  [theme.breakpoints.up("md")]: {
    flex: "0 1 200px",
  },
}));

const ExportButton = styled(Button)({
  marginLeft: "auto",
});

const MasterReportSorting = ({ sortBy, thenBy, sortOrder, groupBy, onSortingChange, onSecondarySortingChange, onGroupByChange, onSortOrderChange, onExport }) => (
  <SortingPaper elevation={2}>
    <SortingField size="small">
      <InputLabel>Sort by</InputLabel>
      <Select label="Sort by" name="sortBy" value={sortBy} onChange={(event) => onSortingChange(event.target.value)}>
        {SORT_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </SortingField>
    <SortingField size="small">
      <InputLabel>Then by</InputLabel>
      <Select label="Then by" name="thenBy" value={thenBy} onChange={(event) => onSecondarySortingChange(event.target.value)}>
        {SORT_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </SortingField>
    <SortingField size="small">
      <InputLabel>Sort order</InputLabel>
      <Select label="Sort order" name="sortOrder" value={sortOrder} onChange={(event) => onSortOrderChange(event.target.value)}>
        <MenuItem value="asc">Ascending</MenuItem>
        <MenuItem value="desc">Descending</MenuItem>
      </Select>
    </SortingField>
    <SortingField size="small">
      <InputLabel>Group by</InputLabel>
      <Select label="Group by" name="groupBy" value={groupBy} onChange={(event) => onGroupByChange(event.target.value)}>
        <MenuItem value="">Flat</MenuItem>
        {GROUP_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </SortingField>
    <Tooltip title="Download every result of this report — all pages, in the order and grouping shown">
      <ExportButton variant="outlined" startIcon={<DownloadIcon />} onClick={onExport}>
        Export to CSV
      </ExportButton>
    </Tooltip>
  </SortingPaper>
);

export default MasterReportSorting;
